import type { SearchSettings } from '~/config/search-settings';

// Centralized storage key
export const STORAGE_KEYS = {
  SETTINGS: 'generatorSettings',
};

// Type for stored settings, potentially including the query
export type StoredSettingsData = Partial<SearchSettings> & { query?: string };

// Parse settings from localStorage
export function getStoredSettings(): StoredSettingsData | null {
  try {
    const savedSettings = localStorage.getItem(STORAGE_KEYS.SETTINGS);
    if (!savedSettings) return null;
    // We assume the stored data might have the query, matching the save logic
    return JSON.parse(savedSettings) as StoredSettingsData;
  } catch (error) {
    console.error('Failed to parse stored settings:', error);
    return null;
  }
}

// Function to save settings (can be used by useSearchSettings)
export function saveSettingsToStorage(
  settings: SearchSettings,
  query: string
): void {
  try {
    const settingsToSave: StoredSettingsData = {
      ...settings,
      query, // Include query when saving
    };
    localStorage.setItem(STORAGE_KEYS.SETTINGS, JSON.stringify(settingsToSave));
  } catch (error) {
    console.error('Failed to save settings to localStorage:', error);
  }
}

// Function to clear settings (can be used by context)
export function clearSettingsFromStorage(): void {
  try {
    localStorage.removeItem(STORAGE_KEYS.SETTINGS);
  } catch (error) {
    console.error('Failed to clear settings from localStorage:', error);
  }
}
